<template>
    <div>
        <v-card flat>
            <slot name="heading">
                
            </slot>
            <v-data-table :headers="headers" :items="unacknowledgedPositions" hide-actions class="elevation-1" disable-initial-sort>
                <template slot="items" slot-scope="props">
                    <tr style="height: 64px;">
                        <td class="text-xs-left">
                            <v-layout row>
                                <v-flex style="align-self: center;">
                                    <a href="#" @click.stop.prevent="loadPositionDescriptionDialog(props.item.positionId, props.item.positionTitle)">{{ props.item.positionTitle }}</a>
                                </v-flex>
                            </v-layout>
                        </td>
                        <td v-if="isLoggedInEmployee" style="width: 1px;">
                            <v-btn color="primary" small @click="loadPositionDescriptionDialog(props.item.positionId, props.item.positionTitle)">Acknowledge</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

        <employee-position-description-dialog 
            :employeeId="employeeId" 
            :id="positionDialogId" 
            :dialog="showPositionDialog"
            :title="positionDialogTitle"
            @closeDialog="onCloseDialog"
            @onAcknowledged="onAcknowledged" />
    </div>
</template>

<script>
    import EmployeePositionDescriptionDialog from '@/components/employee/EmployeePositionDescriptionDialog';
	export default {
        components: {
            EmployeePositionDescriptionDialog
        },
		props: {
            employeeId: {
                type: String,
                required: true
            },
			unacknowledgedPositions: {
				type: Array,
				required: true
			},
            isLoggedInEmployee: {
                type: Boolean
            }
		},
		data() {
			return {
				search: null,
				headers: [
					{ text: 'Position Name', value: 'name' }
				],
                showPositionDialog: false,
                positionDialogId: null,
                positionDialogTitle: null
			};
		},
        created() {
            if (this.isLoggedInEmployee) {
                this.headers.push({ text: '', value: 'actions', sortable: false });
            }
        },
        methods: {
			loadPositionDescriptionDialog(positionId, positionTitle) {
                this.showPositionDialog = true;
                this.positionDialogId = positionId;
                this.positionDialogTitle = positionTitle;
            },
            onCloseDialog() {
                this.showPositionDialog = false;
                this.positionDialogId = null;
                this.positionDialogTitle = null;
            },
            onAcknowledged() {
                this.$emit("onUpdated", "Position Description has been acknowledged, it is now Live");
                this.onCloseDialog();
            }
		},
	};
</script>

<style scoped>
	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
	}
</style>
